import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAdminLogin, ADMIN_CREDENTIALS } from '../utils/storage';
import './AdminLogin.css';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
            setAdminLogin(true);
            navigate('/admin/dashboard');
        } else {
            setError('Invalid username or password');
        }
    };

    return (
        <div className="admin-login">
            <div className="admin-login-container">
                <div className="admin-login-box">
                    <h2>Admin Login</h2>
                    <p className="admin-subtitle">F.A Real Estate CMS</p>
                    <form onSubmit={handleSubmit}>
                        {error && <div className="error-message">{error}</div>}
                        <div className="form-group">
                            <label>Username</label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="Enter username"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter password"
                            />
                        </div>
                        <button type="submit" className="login-btn">Login</button>
                    </form>
                    <div className="admin-note">
                        <p>Default credentials:</p>
                        <p>Username: <strong>admin</strong></p>
                        <p>Password: <strong>admin123</strong></p>
                    </div>
                    <a href="/" className="back-home">← Back to Home</a>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
